import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Attachment } from '@assess/browser/api';
import { trackByFunctions } from '@assess/browser/track-by-functions';
import { IAttachment } from '@assess/shared/entities';
import { Nullable } from '@assess/shared/type-utilities';

@Component({
  selector: 'assess-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsListComponent {
  @Input() attachments: Nullable<(Attachment | IAttachment)[]>;
  @Input() deleteDisabled: Nullable<boolean>;
  @Input() downloadDisabled: Nullable<boolean>;

  @Output() readonly delete = new EventEmitter<Attachment | IAttachment>();
  @Output() readonly download = new EventEmitter<Attachment | IAttachment>();

  readonly trackById = trackByFunctions.byId;

  onDelete(attachment: Attachment | IAttachment) {
    if (!this.deleteDisabled) {
      this.delete.emit(attachment);
    }
  }

  onDownload(attachment: Attachment | IAttachment) {
    if (!this.downloadDisabled) {
      this.download.emit(attachment);
    }
  }
}
